/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useState } from 'preact/hooks';
import { Fragment } from 'preact';
import AppState from '@state';

import { postOrgCWR } from '@api/restricted/org-cwr-api';

import BaseEditOverlay from '@layouts/full-screen/baseEditOverlay';

import ConversationPrompt from '@distinct-components/conversations/conversationPrompt';
import SecondaryText from '@ui-kit/typography/secondaryText';
import AlertMessage from '@ui-kit/alert/Alert';
import BaseButton from '@ui-kit/buttons/baseButton';
import Text from '@ui-kit/typography/text';
import DragAndDrop from '@distinct-components/files/dragAndDrop';

function PublisherUploadCWR({
  loadCompositions,
  closeFunction,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);

  const useToastAlertSuccess = (message) => {
    AppState.messages.toastMessage.value = { text: message, variant: 'success' };
  };

  const handleAddFile = (files) => {
    setError(null);
    const fileToAdd = files[0];
    if (!fileToAdd) {
      setError('Invalid file');
      setFile(null);
      return;
    }
    setFile(fileToAdd);
  };

  const handleSubmitFile = () => {
    setIsLoading(true);
    setError(null);

    postOrgCWR(AppState.pubOrganization.id.value, file)
      .then((response) => {
        if (response.status !== 200) {
          setIsLoading(false);
          response.json()
            .then((json) => setError(json.error || response.statusText))
            .catch(() => setError(response.statusText));
        } else {
          response.json().then((json) => {
            loadCompositions().then(() => {
              setIsLoading(false);
              setFile(null);
              useToastAlertSuccess(`Ingested ${json.numCompositions} composition${json.numCompositions > 1 ? 's' : ''}`);
              closeFunction();
            });
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setError(err.message);
      });
  };

  return (
    <BaseEditOverlay formWidth="24rem" formCentered closeFunction={closeFunction} >
      <ConversationPrompt
        primaryMessage="Import Composition Data"
        promptLabel="CWR Import"
        mb="0.875em"
      />
      <SecondaryText mb="0.875rem">Add a valid CWR file below to import records.</SecondaryText>

      <SecondaryText mb="1.5rem">Imported Compositions are read-only records but allow you to view and manage all your compositions in one place.</SecondaryText>

      <Fragment>
        <Text mb="1em" fontSize="0.813rem">Upload Your CWR File</Text>
        <DragAndDrop
          handleFilesAdded={handleAddFile}
          disabled={isLoading}
          id="file-drop"
        />

        {file && (
        <Text mb="1em" fontSize="0.813rem">
          File Added:
          {' '}
          {file.name}
        </Text>
        )}

        {error && (
        <AlertMessage
          variant="negative"
          message={error}
          mb="1.5em"
          mt="1.5em"
        />
        )}

        {file && <BaseButton mb="1.5em" btnText="Import Data" fluid isLoading={isLoading} onClick={handleSubmitFile} />}
      </Fragment>

    </BaseEditOverlay>
  );
}

PublisherUploadCWR.propTypes = {
  loadCompositions: PropTypes.func.isRequired,
  closeFunction: PropTypes.func.isRequired,
};

export default PublisherUploadCWR;
